module.exports = __webpack_public_path__ + "assets/img/wechat.fc73f894.jpg";